import styled from 'styled-components';
import { COLORS, DEVICES } from '@/theme';
import { Layout } from '@/ui';

export const StyledPageWrapper = styled.div`
  background: ${COLORS.WHITE};
  min-height: 100vh;
  align-items: center;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding-top: 4.125rem;
    background: initial;
    min-height: 85vh;
    display: flex;
    align-items: flex-start;
  }
`;

export const StyledFormWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: ${COLORS.GREY};
  padding: 2rem;
  max-width: 32rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border: 1px solid ${COLORS.GREY_VERY_LIGHT};
  background: ${COLORS.WHITE};

  &&& input {
    background: ${COLORS.WHITE};
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    height: 100%;
    margin-left: 6.875rem;
    border-radius: 0.5rem;
  }
`;

export const StyledLayout = styled(Layout)`
  &.ant-layout {
    min-height: 100vh;
    background: ${COLORS.WHITE};
  }
`;
